import React from 'react'
import { ScopeSectionProps } from './ScopeSection.types'
import styles from './ScopeSection.module.scss'
import {
  H2,
  ImageLabelLine,
  ImageLabelLineProps,
  MultiSelect,
  ObjectSelectSection,
  SectionContainer,
  Text1
} from 'components/shared'
import { Select } from 'components/shared/Select'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { AGREEMENT_PAGE_STORE } from 'store'
import { toJS } from 'mobx'

const ScopeSectionComponent = (props: ScopeSectionProps) => {
  const {
    [AGREEMENT_PAGE_STORE]: {
      storeDropdownOptions,
      onStoreSelect,
      scopeStoreId,
      productsOptionList,
      onProductSelect,
      selectedProductsList,
      onSelectAllProducts,
      projectOptionList,
      onSelectedProjectsChange,
      selectedProjectIds,
      getChangeByKeyId
    }
  } = props

  console.log(toJS(projectOptionList))
  return (
    <SectionContainer className={styles.pageSection} extraPaddingBottom>
      {/* <H2>Agreement scope</H2> */}
      <SectionContainer preset='secondary' className={styles.pageSection}>
        <Text1>This agreement is valid for:</Text1>
        <Text1 bold style={{ marginTop: 16, marginBottom: 6 }}>Store</Text1>
        <Select<number, ImageLabelLineProps>
          options={storeDropdownOptions}
          noNoneOption
          customOptionComponent={ImageLabelLine}
          onChange={onStoreSelect}
          value={scopeStoreId}
          versionChange={getChangeByKeyId('store')}
        />

        {Boolean(scopeStoreId) && (
          <>
            <Text1 bold style={{ marginTop: 16, marginBottom: 6 }}>Projects</Text1>
            <MultiSelect<number>
              placeholder='Select project/s'
              options={projectOptionList}
              value={selectedProjectIds}
              onChange={onSelectedProjectsChange}
              closeMenuOnSelect={false}
              style={ { width: '200px' } }
            />

            <Text1 bold style={{ marginTop: 16, marginBottom: 6 }}>Products</Text1>
            <ObjectSelectSection
              list={productsOptionList}
              selected={selectedProductsList}
              onSelectAllClick={onSelectAllProducts}
              onObjectClick={onProductSelect}
            />
          </>
        )}

      </SectionContainer>
    </SectionContainer>
  )
}

const ScopeSection = inject(
  AGREEMENT_PAGE_STORE
)(observer(ScopeSectionComponent))
export { ScopeSection }
